<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p22"><span><a id="page_18"></a><a href="#/Contents#rp22">CREAM OF TOMATO SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>A soup similar to the favorite-brand canned tomato soup we all remember eating as kids! Canned tomatoes are necessary for the flavor, so don’t substitute fresh.</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>2 cans (14½ ounces each) reduced-sodium whole tomatoes, undrained</span></p>
<p class="hang"><span>1–3 teaspoons beef bouillon crystals</span></p>
<p class="hang"><span>2 cups fat-free milk</span></p>
<p class="hang"><span>3 tablespoons cornstarch</span></p>
<p class="hang"><span>⅛ teaspoon baking soda</span></p>
<p class="hang"><span>2 teaspoons sugar</span></p>
<p class="hang"><span>1–2 tablespoons margarine or butter</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Process tomatoes with liquid in food processor or blender until smooth; heat tomatoes and bouillon crystals to boiling in large saucepan. Stir in combined milk and cornstarch, stirring until thickened, about 1 minute. Add baking soda, sugar, and margarine, stirring until margarine is melted. Season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 142</span></p>
<p class="per1"><span>% calories from fat: 22</span></p>
<p class="per1"><span>Protein (g): 6.3</span></p>
<p class="per1"><span>Carbohydrate (g): 22.6</span></p>
<p class="per1"><span>Fat (g): 3.7</span></p>
<p class="per1"><span>Saturated fat (g): 0.8</span></p>
<p class="per1"><span>Cholesterol (mg): 2</span></p>
<p class="per1"><span>Sodium (mg): 395</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.5</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter024.vue?1b5ce336